import { combineReducers } from 'redux';

import { alert } from './alert.reducer';
import { user } from './user.reducer';
import { account } from './account/account.reducer';
import { authentication } from './authentication.reducer';
import { cms } from './cms/cms.reducer';
import { template } from './cms/template/template.reducer';
import { language } from './system/language/language.reducer';
import { event } from './event/event.reducer';
import { systemLabels } from './system/systemLabel/systemLabels.reducer';
import { globals } from './global.reducer';
import { question } from './question/question.reducer';
import { eventLabel } from './event/eventLabel.reducer';


export default combineReducers({
  alert,
  user,
  account,
  authentication,
  template,
  language,
  event,
  systemLabels,
  globals,
  account,
  cms,
  question,
  eventLabel
})
